import Vue from 'vue'
import VueRouter from 'vue-router'
import FrameOuter from './FrameOuter'

Vue.use(VueRouter);

const routes = [
    {
      path: '/',
      redirect: {
        name: 'productCenter',
      },
    },
    // 产品中心
    {
      path: '/productCenter',
      name: 'productCenter',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 创建应用
    {
      path: '/productCenter/createProduct',
      name: 'createProduct',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 账户与授权
    {
      path: '/account/main/index',
      name: 'account',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/account-authorization/index.vue'], resolve),
    },
    //新增授权账户
    {
      path: '/account/main/index/edit',
      name: 'editAuthorization',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/account-edit/index.vue'], resolve),
    },
    // 应用概览
    {
      path: '/analytics/overview/app/:productid',
      name: 'analytics',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/analytics/index.vue'], resolve),
    },
    // 用户趋势
    {
      path: '/analytics/overview/trend/:productid',
      name: 'trend',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/trend/index.vue'], resolve),
    },
    // 渠道分析
    {
      path: '/analytics/overview/channel/:productid',
      name: 'channel',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/channel/index.vue'], resolve),
    },
    // 渠道分析详情
    {
      path: '/analytics/overview/channel/:productid/:channelName',
      name: 'channelDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/channel-detail/index.vue'], resolve),
    },
    // 卸载分析引导页
    {
      path: '/analytics/overview/uninstallOpen/:productid',
      name: 'uninstallOpen',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 卸载分析趋势页面
    {
      path: '/analytics/overview/uninstallAnalytics/:productid',
      name: 'uninstallAnalytics',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 留存分析
    {
      path: '/analytics/overview/keepuser/:productid',
      name: 'keepuser',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/keepuser/index.vue'], resolve),
    },
    // 我的看板
    {
      path: '/dashboard/main/:productid',
      name: 'dashboard',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 游戏专项分析
    {
      path: '/gameReport/main/:productid',
      name: 'gameReport',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 扫码详情
    {
      path: '/analytics/overview/scan/:productid/:qcodeid',
      name: 'scanDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/scan-detail/index.vue'], resolve),
    },
    // 扫码分析
    {
      path: '/analytics/overview/scan/:productid',
      name: 'scanAnalysis',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/scan-analysis/index.vue'], resolve),
    },
    // 场景分布详情
    {
      path: '/analytics/overview/scene/:productid/:sceneid',
      name: 'sceneDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/scene-detail/index.vue'], resolve),
    },
    // 场景分析
    {
      path: '/analytics/overview/scene/:productid',
      name: 'sceneAnalysis',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/scene-analysis/index.vue'], resolve),
    },
    // 分享及传播
    {
      path: '/analytics/overview/share/:productid',
      name: 'shareAnalytics',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/share-dissemination/index.vue'], resolve),
    },
    // 分享及传播页面详情
    {
      path: '/analytics/overview/share/page/:productid/:pageid',
      name: 'sharePageDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/share-detail/index.vue'], resolve),
    },
    //用户质量评估
    {
      path: '/analytics/overview/quality/:productid',
      name: 'quality',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/quality/index.vue'], resolve),
    },
    //用户质量评估详情
    {
      path: '/analytics/overview/quality/:productid/:partnerid',
      name: 'qualityDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/quality-detail/index.vue'], resolve),
    },
    // 复购分析
    {
      path: '/analytics/business/purchase/:productid',
      name: 'purchase',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/business-analysis/index.vue'], resolve),
    },
    // 交易分析
    {
      path: '/analytics/business/transaction/:productid',
      name: 'Transaction',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/transaction-analysis/index.vue'], resolve),
    },
    // 用户画像
    {
      path: '/analytics/user/userPortrait/:productid',
      name: 'userPortrait',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/user-portrait/index.vue'], resolve),
    },
    // 用户分群
    {
      path: '/analytics/user/group/:productid',
      name: 'userGroup',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/user-group/index.vue'], resolve),
    },
    {
      path: '/analytics/user/mc/:productid',
      name: 'mcDrainage',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 创建、编辑用户分群
    {
      path: '/analytics/user/group/edit/:productid/:cohortId',
      name: 'addNewGroup',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/add-usergroup/index.vue'], resolve),
    },
    // 页面访问
    {
      path: '/analytics/behavior/page/:productid',
      name: 'pageAccess',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/page-access/index.vue'], resolve),
    },
    // 事件分析
    {
      path: '/analytics/behavior/events/:productid',
      name: 'eventsBehavior',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 事件分析详情-新
    {
      path: '/analytics/behavior/events/:productid/detail',
      name: 'EventDetail',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 基本信息页面
    {
      path: '/manage/overview/info/:productid',
      name: 'info-manage',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/info-manage/index.vue'], resolve),
    },
    // 二维码管理form表单版
    {
      path: '/manage/overview/qrcode/:productid',
      name: 'qrCode',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/qrcode-manage/index.vue'], resolve),
    },
    // 版本管理
    {
      path: '/manage/overview/version/:productid',
      name: 'version',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/user-version/index.vue'], resolve),
    },
    // 转化漏斗
    {
      path: '/analytics/behavior/funnel/:productid',
      name: 'funnel',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/trans-funnel/index.vue'], resolve),
    },
    // 编辑漏斗
    {
      path: '/analytics/behavior/funnel/setFunnel/:productid/:funnelname',
      name: 'setfunnel',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/set-funnel/index.vue'], resolve),
    },
    // 漏斗详情展示
    {
      path: '/analytics/behavior/funnel/funnelChart/:productid/:funnelname',
      name: 'funnelchart',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/funnel-chart/index.vue'], resolve),
    },
    //灵动分析-扫一扫
    {
      path: '/analytics/behavior/smart-scan/:productid',
      name: 'smart-new',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/smart-scan/index.vue'], resolve),
    },
    // 数据探索
    {
      path: '/analytics/exploration/overview/:productid',
      name: 'exploration',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    {
      path: '/analytics/exploration/event/:productid',
      name: 'exploreEvent',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //渠道管理
    {
      path: '/manage/overview/channel/:productid',
      name: 'channelManage',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/channel-manage/index.vue'], resolve),
    },
    //错误分析
    {
      path: '/helper/err/info/:productid',
      name: 'errorInfo',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/error-analytics/index.vue'], resolve),
    },
    //错误列表
    {
      path: '/helper/err/list/:productid',
      name: 'errorList',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/error-list/index.vue'], resolve),
    },
    //错误详情
    {
      path: '/helper/err/detail/:productid',
      name: 'errorDetail',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/error-details/index.vue'], resolve),
    },
    //新日志导出-main
    {
      path: '/helper/exportData/main/:productid',
      name: 'exportData',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //推送营销
    {
      path: '/push/main/index/:productid',
      name: 'push',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //推送配置
    {
      path: '/push/options/index/:productid',
      name: 'pushOptions',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //数据接口
    {
      path: '/manage/overview/openapi/:productid',
      name: 'openapi',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/openapi/index.vue'], resolve),
    },
    //短信设置
    {
      path: '/helper/eauth/message/:productid',
      name: 'message',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 易认证-详情
    {
      path: '/helper/eauth/list/:productid',
      name: 'Elist',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    // 易认证-概览
    {
      path: '/helper/eauth/overview/:productid',
      name: 'Eoverview',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //易认证-欢迎
    {
      path: '/helper/eauth/welcome/:productid',
      name: 'Ewelcome',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //事件管理
    {
      path: '/manage/overview/event/:productid',
      name: 'eventManage',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //参数管理
    {
      path: '/manage/overview/event/:productid/param',
      name: 'ParamManage',
      // eslint-disable-next-line
      component: FrameOuter,
    },
    //订阅服务
    {
      path: '/manage/overview/subscription/:productid',
      name: 'subscription',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/subscription-list/index.vue'], resolve),
    },
    //订阅服务-新建、编辑
    {
      path: '/manage/overview/subscription/subscription-edit/:productid/:subId',
      name: 'subscriptionEdit',
      // eslint-disable-next-line
      component: (resolve) => require(['../views/subscription-edit/index.vue'], resolve),
    },
]

const router = new VueRouter({
  routes
})

export default router
